export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";

export const searchType = [
  { label: "Billing Category", value: "billingCategoryIds" },
  { label: "Transaction Type", value: "transactionType" },
  { label: "Frequency", value: "frequency" },
];